import $ from 'jquery';

function get(url, token) {
    return fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        credentials: 'include'
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw response.status;
        }
    });
}

function post(url, data, token) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + token
        },
        credentials: 'include',
        body: data
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw response.status;
        }
    });
}

function postJson(url, data, token) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        credentials: 'include',
        body: JSON.stringify(data)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw response.status;
        }
    });
}

function form(url, formData, token, callback) {
    return new Promise(resolve => {
        $.ajax(
            {
                type: 'POST',
                url: url,
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                processData: false,
                contentType: false,
                data: formData,
                xhr: () => {
                    let myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                        myXhr.upload.addEventListener('progress', function (e) {
                            let loaded = e.loaded;
                            let total = e.total;
                            let percent = Math.floor(100 * loaded / total);
                            if (callback !== undefined) {
                                callback(percent);
                            }
                        }, false);
                    }
                    return myXhr;
                },
                success: response => {
                    resolve(response);
                }
            }
        );
    });
}

function put(url, data, token) {
    return fetch(url, {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        credentials: 'include',
        body: JSON.stringify(data)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw response.status;
        }
    });
}

function delete1(url, data, token) {
    return fetch(url, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        credentials: 'include',
        body: JSON.stringify(data)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw response.status;
        }
    });
}


export {
    get,
    post,
    postJson,
    form,
    put,
    delete1
}


// WEBPACK FOOTER //
// ./src/utils/httpUtils.js